import React from "react";
import { Navigate } from "react-router";

const LoginRoute = ({ children }) => {
  const tokenData = JSON.parse(sessionStorage.getItem('token'));
  const isTokenValid = tokenData && (new Date().getTime() - tokenData.timestamp < 24 * 60 * 60 * 1000);

  if (isTokenValid) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default LoginRoute;
